import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BadgeCouponCode } from '@app/model/badge-coupon-code';
import { HydraResponseDto } from '@app/model/hydra-response-dto';
import { HttpService } from 'library-explorer';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BadgeCouponApiService {

  constructor(private readonly httpService: HttpService) { }

  public createBadgeCouponCode(id: string, badgeId: string): Observable<BadgeCouponCode> {
    return this.httpService.postCore<BadgeCouponCode>(`/badges/coupons/${id}/codes/issues`, { badgeId })
  }

  public getBadgeCouponCodeCollection(badgeId: string, page = 1): Observable<HydraResponseDto<BadgeCouponCode>> {
    const params = new HttpParams().set('page', page);
    return this.httpService.getCore<HydraResponseDto<BadgeCouponCode>>(`/badges/${badgeId}/coupons/codes/issues`, params);
  }
}
